@use "styles" as *;

.me-pipe-separator {
  display: inline-block;
}
